import { iaRa } from 'lib/helpers/utility';

export const checkActiveItem = (switchItems, status, location) => {
  const selectedItem = iaRa(switchItems).find((item) => {
    if (status) {
      return item.value === status;
    }
    return item.navigate === location.pathname || null;
  });

  return selectedItem;
};
